<template>
  <div>
    <vs-card>
      <b-col cols="12" style="padding-right: 20px">
        <b-row align-h="start">
          <b-col cols="3" align-self="center"
            ><b-form-input
              v-model="arananDeger"
              @keyup.enter="getStokList"
              id="smallInput"
              placeholder="Arama..."
            />
          </b-col>
          <b-col cols="12" md="auto">
            <vs-button
              style="border-radius: 5px"
              @click="getStokList()"
              type="gradient"
              id="button-with-loading-yeni"
              class="vs-con-loading__container"
              >Listele</vs-button
            >
          </b-col>
          <b-col cols="12" md="auto">
            <vs-button
              style="border-radius: 5px"
              @click="yeniKayit()"
              type="gradient"
              color="danger"
              >Yeni Kayıt</vs-button
            >
          </b-col>
        </b-row>
      </b-col>
    </vs-card>
    <vs-card>
      <ag-grid-vue
        style="width: 100%; height: 500px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowdata"
        :animateRows="true"
        :pagination="true"
        :localeText="localeText"
        :suppressCopyRowsToClipboard="true"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
        :rowSelection="rowSelection"
      >
      </ag-grid-vue>
    </vs-card>
    <b-modal
      ref="modal-yeniStok"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Stok Detay"
      size="xl"
      hide-footer
    >
      <vx-card style="padding: 0px">
        <form-wizard
          :title="null"
          :subtitle="null"
          finishButtonText="Tamam"
          @on-complete="stokKaydet"
          nextButtonText="Sonraki"
          backButtonText="Önceki"
          color="rgba(var(--vs-primary), 1)"
          errorColor="rgba(var(--vs-danger), 1)"
          :start-index="startIndexValue"
        >
          <tab-content
            class="mb-5"
            icon="feather icon-map"
            :before-change="validateStep1"
          >
            <!-- tab 1 content -->
            <form data-vv-scope="step-1">
              <vs-card style="min-height: 300px">
                <b-row>
                  <b-col cols="4">
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Stok Adı"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="STOCKNAME"
                          v-validate="'required'"
                          name="stock_name"
                        />
                        <span class="text-danger">{{
                          errors.first("step-1.stock_name")
                        }}</span>
                      </b-col>
                    </b-row>

                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Stok Adı 2"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="STOCKNAME2"
                        />
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Stok Tipi"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <v-select
                          v-model="STOCKTYPE"
                          :options="STOCKTYPEOPTION"
                          label="name"
                          autocomplete
                          v-validate="'required'"
                          name="stok_type"
                        >
                        </v-select>
                        <span class="text-danger">{{
                          errors.first("step-1.stok_type")
                        }}</span>
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Stok Kodu"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="STOCKNO"
                          v-validate="'required'"
                          name="stok_kodu"
                        />
                        <span class="text-danger">{{
                          errors.first("step-1.stok_kodu")
                        }}</span>
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Durum"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <v-select
                          v-model="STATUS"
                          :options="STATUSOPTION"
                          label="name"
                          autocomplete
                        >
                        </v-select>
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Depo"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7" style="padding-right: 0px;">
                        <b-form-input
                          size="sm"
                          disabled
                          id="h-first-name"
                          v-model="DEPOTID"
                        />
                      </b-col>
                      <b-col cols="1" style="padding-left: 0px;">
                        <b-button
                          variant="outline-light"
                          style="padding: 0px;"
                          v-on:click="
                            secimYap('DEPOTID');
                            secimTitle = 'Depo Yönetimi';
                          "
                          ><Icon
                            icon="fluent-mdl2:document-management"
                            width="22"
                            height="22"
                            v-b-tooltip.hover.bottom="'Depo Yönetimi'"
                            color="#7367F0"
                        /></b-button>
                      </b-col>
                    </b-row>

                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Birim"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7" style="padding-right: 0px;">
                        <b-form-input
                          size="sm"
                          disabled
                          id="h-first-name"
                          v-model="UNIT"
                        />
                      </b-col>
                      <b-col cols="1" style="padding-left: 0px;">
                        <b-button
                          variant="outline-light"
                          style="padding: 0px;"
                          v-on:click="
                            secimYap('UNIT');
                            secimTitle = 'Birim Yönetimi';
                          "
                          ><Icon
                            icon="fluent-mdl2:document-management"
                            width="22"
                            height="22"
                            v-b-tooltip.hover.bottom="'Birim Yönetimi'"
                            color="#7367F0"
                        /></b-button>
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Kdv"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="VATSALES"
                          name="stok_kdv"
                          v-validate="'required'"
                        />
                        <span class="text-danger">{{
                          errors.first("step-1.stok_kdv")
                        }}</span>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col cols="4">
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Dönem"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="SEASON"
                        />
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Marka"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="BRAND"
                        />
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Model"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="MODEL"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Müşteri Stok No"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="CUSTOMERSTOCKNO"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Tedarikçi Stok No"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="SUPPLIERSTOCKNO"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Orijin"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="ORIGIN"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Grup Kodu"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7" style="padding-right: 0px;">
                        <b-form-input
                          size="sm"
                          disabled
                          id="h-first-name"
                          v-model="GROUPCODE"
                        />
                      </b-col>
                      <b-col cols="1" style="padding-left: 0px;">
                        <b-button
                          variant="outline-light"
                          style="padding: 0px;"
                          v-on:click="
                            secimYap('GROUPCODE');
                            secimTitle = 'Grup Kodu Yönetimi';
                          "
                          ><Icon
                            icon="fluent-mdl2:document-management"
                            width="22"
                            height="22"
                            v-b-tooltip.hover.bottom="'Grup Kodu Yönetimi'"
                            color="#7367F0"
                        /></b-button>
                      </b-col>
                    </b-row>

                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Özel Kod 1"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7" style="padding-right: 0px;">
                        <b-form-input
                          size="sm"
                          disabled
                          id="h-first-name"
                          v-model="SPECCODE1"
                        />
                      </b-col>
                      <b-col cols="1" style="padding-left: 0px;">
                        <b-button
                          variant="outline-light"
                          style="padding: 0px;"
                          v-on:click="
                            secimYap('SPECCODE1');
                            secimTitle = 'Özel Kod 1 Yönetimi';
                          "
                          ><Icon
                            icon="fluent-mdl2:document-management"
                            width="22"
                            height="22"
                            v-b-tooltip.hover.bottom="'Özel Kod 1 Yönetimi'"
                            color="#7367F0"
                        /></b-button>
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Özel Kod 2"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7" style="padding-right: 0px;">
                        <b-form-input
                          size="sm"
                          disabled
                          id="h-first-name"
                          v-model="SPECCODE2"
                        />
                      </b-col>
                      <b-col cols="1" style="padding-left: 0px;">
                        <b-button
                          variant="outline-light"
                          style="padding: 0px;"
                          v-on:click="
                            secimYap('SPECCODE2');
                            secimTitle = 'Özel Kod Yönetimi';
                          "
                          ><Icon
                            icon="fluent-mdl2:document-management"
                            width="22"
                            height="22"
                            v-b-tooltip.hover.bottom="'Özel Kod Yönetimi'"
                            color="#7367F0"
                        /></b-button>
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Özel Kod 3"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7" style="padding-right: 0px;">
                        <b-form-input
                          size="sm"
                          disabled
                          id="h-first-name"
                          v-model="SPECCODE3"
                        />
                      </b-col>
                      <b-col cols="1" style="padding-left: 0px;">
                        <b-button
                          variant="outline-light"
                          style="padding: 0px;"
                          v-on:click="
                            secimYap('SPECCODE3');
                            secimTitle = 'Özel Kod Yönetimi';
                          "
                          ><Icon
                            icon="fluent-mdl2:document-management"
                            width="22"
                            height="22"
                            v-b-tooltip.hover.bottom="'Özel Kod Yönetimi'"
                            color="#7367F0"
                        /></b-button>
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Özel Kod 4"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7" style="padding-right: 0px;">
                        <b-form-input
                          size="sm"
                          disabled
                          id="h-first-name"
                          v-model="SPECCODE4"
                        />
                      </b-col>
                      <b-col cols="1" style="padding-left: 0px;">
                        <b-button
                          variant="outline-light"
                          style="padding: 0px;"
                          v-on:click="
                            secimYap('SPECCODE4');
                            secimTitle = 'Özel Kod Yönetimi';
                          "
                          ><Icon
                            icon="fluent-mdl2:document-management"
                            width="22"
                            height="22"
                            v-b-tooltip.hover.bottom="'Özel Kod Yönetimi'"
                            color="#7367F0"
                        /></b-button>
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Özel Kod 5"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7" style="padding-right: 0px;">
                        <b-form-input
                          size="sm"
                          disabled
                          id="h-first-name"
                          v-model="SPECCODE5"
                        />
                      </b-col>
                      <b-col cols="1" style="padding-left: 0px;">
                        <b-button
                          variant="outline-light"
                          style="padding: 0px;"
                          v-on:click="
                            secimYap('SPECCODE5');
                            secimTitle = 'Özel Kod Yönetimi';
                          "
                          ><Icon
                            icon="fluent-mdl2:document-management"
                            width="22"
                            height="22"
                            v-b-tooltip.hover.bottom="'Özel Kod Yönetimi'"
                            color="#7367F0"
                        /></b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </vs-card>
            </form>
          </tab-content>

          <!-- tab 2 content -->
          <tab-content class="mb-5" icon="feather icon-file-text">
            <form data-vv-scope="step-1">
              <vs-card style="min-height: 300px">
                <b-row>
                  <b-col cols="4">
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Döviz"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7" style="padding-right: 0px;">
                        <b-form-input
                          size="sm"
                          disabled
                          id="h-first-name"
                          v-model="CURRCODE"
                        />
                      </b-col>
                      <b-col cols="1" style="padding-left: 0px;">
                        <b-button
                          variant="outline-light"
                          style="padding: 0px;"
                          v-on:click="
                            secimYap('CURRCODE');
                            secimTitle = 'Döviz Yönetimi';
                          "
                          ><Icon
                            icon="fluent-mdl2:document-management"
                            width="22"
                            height="22"
                            v-b-tooltip.hover.bottom="'Döviz Yönetimi'"
                            color="#7367F0"
                        /></b-button>
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Fiyat 1"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="PRICE1"
                        />
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Fiyat 2"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="PRICE2"
                        />
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Fiyat 3"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="PRICE3"
                        />
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Fiyat 4"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="PRICE4"
                        />
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Fiyat 5"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="PRICE5"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Kategori 1"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7" style="padding-right: 0px;">
                        <b-form-input
                          size="sm"
                          disabled
                          id="h-first-name"
                          v-model="CATAGORY1"
                        />
                      </b-col>
                      <b-col cols="1" style="padding-left: 0px;">
                        <b-button
                          variant="outline-light"
                          style="padding: 0px;"
                          v-on:click="
                            secimYap('CATAGORY1');
                            secimTitle = 'Kategori Yönetimi';
                          "
                          ><Icon
                            icon="fluent-mdl2:document-management"
                            width="22"
                            height="22"
                            v-b-tooltip.hover.bottom="'Kategori Yönetimi'"
                            color="#7367F0"
                        /></b-button>
                      </b-col>
                    </b-row>

                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Kategori 2"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7" style="padding-right: 0px;">
                        <b-form-input
                          size="sm"
                          disabled
                          id="h-first-name"
                          v-model="CATAGORY2"
                        />
                      </b-col>

                      <b-col cols="1" style="padding-left: 0px;">
                        <b-button
                          variant="outline-light"
                          style="padding: 0px;"
                          v-on:click="
                            secimYap('CATAGORY2');
                            secimTitle = 'Kategori Yönetimi';
                          "
                          ><Icon
                            icon="fluent-mdl2:document-management"
                            width="22"
                            height="22"
                            v-b-tooltip.hover.bottom="'Kategori Yönetimi'"
                            color="#7367F0"
                        /></b-button>
                      </b-col>
                    </b-row>

                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Kategori 3"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7" style="padding-right: 0px;">
                        <b-form-input
                          size="sm"
                          disabled
                          id="h-first-name"
                          v-model="CATAGORY3"
                        />
                      </b-col>
                      <b-col cols="1" style="padding-left: 0px;">
                        <b-button
                          variant="outline-light"
                          style="padding: 0px;"
                          v-on:click="
                            secimYap('CATAGORY3');
                            secimTitle = 'Kategori Yönetimi';
                          "
                          ><Icon
                            icon="fluent-mdl2:document-management"
                            width="22"
                            height="22"
                            v-b-tooltip.hover.bottom="'Kategori Yönetimi'"
                            color="#7367F0"
                        /></b-button>
                      </b-col>
                    </b-row>

                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Kategori 4"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7" style="padding-right: 0px;">
                        <b-form-input
                          size="sm"
                          disabled
                          id="h-first-name"
                          v-model="CATAGORY4"
                        />
                      </b-col>
                      <b-col cols="1" style="padding-left: 0px;">
                        <b-button
                          variant="outline-light"
                          style="padding: 0px;"
                          v-on:click="
                            secimYap('CATAGORY4');
                            secimTitle = 'Kategori Yönetimi';
                          "
                          ><Icon
                            icon="fluent-mdl2:document-management"
                            width="22"
                            height="22"
                            v-b-tooltip.hover.bottom="'Kategori Yönetimi'"
                            color="#7367F0"
                        /></b-button>
                      </b-col>
                    </b-row>

                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Kategori 5"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7" style="padding-right: 0px;">
                        <b-form-input
                          size="sm"
                          disabled
                          id="h-first-name"
                          v-model="CATAGORY5"
                        />
                      </b-col>
                      <b-col cols="1" style="padding-left: 0px;">
                        <b-button
                          variant="outline-light"
                          style="padding: 0px;"
                          v-on:click="
                            secimYap('CATAGORY5');
                            secimTitle = 'Kategori Yönetimi';
                          "
                          ><Icon
                            icon="fluent-mdl2:document-management"
                            width="22"
                            height="22"
                            v-b-tooltip.hover.bottom="'Kategori Yönetimi'"
                            color="#7367F0"
                        /></b-button>
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Açıklama"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-textarea v-model="DESCRIPTION" />
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col cols="4">
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Barkod "
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="BARCODE"
                        />
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Barkod 1"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="BARCODE1"
                        />
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Barkod 2"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="BARCODE2"
                        />
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Barkod 3"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="BARCODE3"
                        />
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Barkod 4"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-input
                          size="sm"
                          id="h-first-name"
                          v-model="BARCODE4"
                        />
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          size="sm"
                          label="Notlar"
                          label-for="h-first-name"
                          style="font-size: 15px"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-textarea v-model="NOTES" />
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px" align-h="end">
                      <b-col cols="6">
                        <vs-checkbox v-model="WEBSTOCK"
                          >Web'de satışı var mı?</vs-checkbox
                        >
                      </b-col>
                    </b-row>
                    <b-row style="margin-bottom: 10px" align-h="end">
                      <b-col cols="6">
                        <vs-checkbox v-model="LOTKAYIT">lot kaydı</vs-checkbox>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </vs-card>
            </form>
          </tab-content>

          <!-- tab 3 content -->
        </form-wizard>
      </vx-card>
    </b-modal>
    <b-modal
      ref="modal-secimYap"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      :title="secimTitle"
      size="md"
      hide-footer
    >
      <vs-card>
        <b-col cols="12" style="padding-right: 20px">
          <b-row align-h="start">
            <b-col cols="6" align-self="center"
              ><b-form-input
                v-model="arananDegerTanim"
                @keyup.enter="getTanimList"
                id="smallInput"
                placeholder="Arama..."
              />
            </b-col>
            <b-col cols="12" md="auto">
              <b-button
                size="sm"
                style="background-color: #7367F0; border-color: #7367F0;"
                v-on:click="getTanimList()"
                ><Icon
                  icon="akar-icons:search"
                  width="20"
                  height="20"
                  v-b-tooltip.hover.bottom="'Listele'"
                />Listele</b-button
              >
            </b-col>
          </b-row>
        </b-col>
      </vs-card>
      <vs-card style="min-height: 250px">
        <div class="demo-inline-spacing">
          <b-form ref="form" @submit.prevent="repeateAgain">
            <b-row>
              <b-col cols="12"> </b-col>
              <b-col cols="12"> </b-col>

              <b-col cols="12">
                <b-row>
                  <b-col cols="5">
                    <p style="text-align: center">Kod</p>
                  </b-col>
                  <b-col cols="5">
                    <p style="text-align: center">Açıklama</p>
                  </b-col>

                  <b-col cols="1"> </b-col>
                </b-row>
              </b-col>

              <b-col cols="12">
                <div :class="scrollview" style="padding-right: 10px;">
                  <b-row
                    v-for="(item, index) in items"
                    :id="item.id"
                    :key="item.id"
                    ref="row"
                  >
                    <!-- Item Name -->
                    <b-col cols="5" style="padding-right: 0">
                      <b-form-group label-for="cost">
                        <b-form-input
                          v-model="item.kod"
                          style="font-size: inherit"
                          id="cost"
                          type="text"
                          placeholder="Kod"
                          :disabled="item.disabled"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="5" style="padding-right: 0">
                      <b-form-group label-for="cost">
                        <b-form-input
                          v-model="item.aciklama"
                          style="font-size: inherit"
                          id="cost"
                          type="text"
                          placeholder="Açıklama"
                          :disabled="item.disabled"
                        />
                      </b-form-group>
                    </b-col>

                    <!-- Quantity -->

                    <b-col
                      style="padding-right: 0"
                      cols="1"
                      class="mb-50"
                      v-if="
                        genelTanim == 'DEPOTID' ||
                          genelTanim == 'UNIT' ||
                          genelTanim == 'CURRCODE' ||
                          genelTanim == 'CATAGORY1' ||
                          genelTanim == 'CATAGORY2' ||
                          genelTanim == 'CATAGORY3' ||
                          genelTanim == 'CATAGORY4' ||
                          genelTanim == 'CATAGORY5'
                      "
                    >
                      <b-col cols="2" class="mb-50">
                        <b-row style="padding: 0">
                          <b-col style="padding: 0"> </b-col>
                          <b-col style="padding: 0">
                            <b-button
                              variant="outline-light"
                              size="sm"
                              v-on:click="secTanim(index)"
                              ><Icon
                                color="#7367F0"
                                icon="material-symbols:select-check-box"
                                width="20"
                                height="20"
                            /></b-button>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-col>
                    <b-col
                      style="padding-right: 0"
                      cols="1"
                      class="mb-50"
                      v-else
                    >
                      <b-col
                        style="padding-right: 0"
                        cols="1"
                        class="mb-50"
                        v-if="item.disabled == false"
                      >
                        <b-row style="padding: 0">
                          <b-col style="padding: 0">
                            <!--
                          <b-button
                            variant="outline-light"
                            size="sm"
                            v-on:click="addTanim(index)"
                            ><Icon
                              color="#28c76f"
                              icon="ic:baseline-save-all"
                              width="20"
                              height="20"
                          /></b-button>-->
                          </b-col>
                        </b-row>
                      </b-col>

                      <b-col cols="2" class="mb-50" v-else>
                        <b-row style="padding: 0">
                          <b-col style="padding: 0">
                            <!--
                          <b-button
                            variant="outline-light"
                            size="sm"
                            v-on:click="addTanim(index, 'DEL')"
                            ><Icon
                              color="#EA5455"
                              icon="ic:baseline-remove-circle"
                              width="20"
                              height="20"
                          /></b-button>-->
                          </b-col>


                          
                          <b-col style="padding: 0">
                            <b-button
                              variant="outline-light"
                              size="sm"
                              v-on:click="secTanim(index)"
                              ><Icon
                                color="#7367F0"
                                icon="material-symbols:select-check-box"
                                width="20"
                                height="20"
                            /></b-button>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-col>
                    <!-- Remove Button -->
                    <b-col cols="12" style="height: 5px"> </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>

            <!-- Row Loop -->
          </b-form>
        </div>
      </vs-card>
    </b-modal>
  </div>
</template>
<script>
import { Validator } from "vee-validate";
import { Icon } from "@iconify/vue2";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import vSelect from "vue-select";
import state from "../../store/state";
import Store from "../../store/store";
import STOCKTYPEGorunumCellRenderer from "./CellRenderers/STOCKTYPEGorunumCellRenderer.vue";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
import DurumGorunumCellRenderer from "./CellRenderers/DurumGorunumCellRenderer.vue";
import ReceteStokPriceCellRenderer from "./CellRenderers/ReceteStokPriceCellRenderer.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import MpStokListesiButton from "../components/uzum-components/mpstokyonetimi-components/MpStokListesiButton.vue";
import {
  BButton,
  BModal,
  VBModal,
  BFormDatepicker,
  BTabs,
  BTab,
  BFormSelect,
  BCardText
} from "bootstrap-vue";
const dict = {
  custom: {
    stock_name: {
      required: "Stok Adı gereklidir",
      alpha: "Stok Adı gereklidir"
    },
    stok_kodu: {
      required: "Stok Kodu gereklidir",
      alpha: "Stok Kodu gereklidir"
    },
    stok_kdv: {
      required: "Stok Kdv gereklidir",
      alpha: "Stok Kdv gereklidir"
    },
    stok_type: {
      required: "Stok Tipi gereklidir",
      alpha: "Stok Tipi gereklidir"
    }
  }
};

// register custom messages
Validator.localize("en", dict);
export default {
  data() {
    return {
      startIndexValue: 0,
      scrollview: "",
      genelTanim: "",
      arananDegerTanim: "",
      STOCKTYPEOPTION: [
        { name: "Mamül", val: "900" },
        { name: "Yarı Mamül", val: "901" },
        { name: "Ham Madde", val: "902" },
        { name: "Diğer", val: "903" },
        { name: "Yardımcı Malzeme", val: "906" },
        { name: "Sarf Malzeme", val: "907" }
      ],
      items: [
        {
          id: 1,
          aciklama: "",
          kod: "",
          disabled: false,
          ROOT: "",
          ROOTFIELD: "",
          COMPANYID: ""
        }
      ],
      secimTitle: "",
      LOTKAYIT: "",
      COMPANYID: "",
      STOCKID: "",
      STOCKNO: "",
      STOCKNAME: "",
      STOCKNAME2: "",
      STATUS: { name: "Aktif", val: 2 },
      DEPOTID: "",
      UNIT: "",
      VATSALES: "",
      VATPURCHASE: "",
      GROUPCODE: "",
      SPECCODE1: "",
      SPECCODE2: "",
      SPECCODE3: "",
      SPECCODE4: "",
      SPECCODE5: "",
      SEASON: "",
      BRAND: "",
      MODEL: "",
      CATAGORY1: "",
      CATAGORY2: "",
      CATAGORY3: "",
      CATAGORY4: "",
      CATAGORY5: "",
      CURRCODE: "",
      PRICE1: "",
      PRICE2: "",
      PRICE3: "",
      PRICE4: "",
      PRICE5: "",
      BARCODE: "",
      BARCODE1: "",
      BARCODE2: "",
      BARCODE3: "",
      BARCODE4: "",
      CUSTOMERSTOCKNO: "",
      SUPPLIERSTOCKNO: "",
      WEBSTOCK: "",
      ORIGIN: "",
      BARKOD: "",
      DESCRIPTION: "",
      NOTES: "",
      INSERTDATE: "",
      INSERTUSER: "",
      EDITDATE: "",
      EDITUSER: "",
      STOCKTYPE: "",
      nextTodoId: 1,

      UNITCODE: "",
      DEPOTIDCODE: "",
      GROUPCODECODE: "",
      SPECCODE1CODE: "",
      SPECCODE2CODE: "",
      SPECCODE3CODE: "",
      SPECCODE4CODE: "",
      SPECCODE5CODE: "",
      CURRCODECODE: "",
      CATAGORY1CODE: "",
      CATAGORY2CODE: "",
      CATAGORY3CODE: "",
      CATAGORY4CODE: "",
      CATAGORY5CODE: "",

      STATUSOPTION: [
        { name: "Aktif", val: 2 },
        { name: "Pasif", val: 3 }
      ],

      arananDeger: "",
      rowSelection: null,
      rowdata: null,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      localeText: null,
      columnDefs: null
    };
  },
  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.rowSelection = "single";
    this.scrollview = "scroll-hand";
    this.getStokList();
    this.startIndexValue = 0;
  },
  components: {
    STOCKTYPEGorunumCellRenderer,
    ReceteStokPriceCellRenderer,
    FormWizard,
    TabContent,
    // SatinalmaPageButon,
    AgGridVue,
    BFormSelect,
    BTabs,
    "v-select": vSelect,
    BFormDatepicker,
    BTab,
    Icon,
    AgGridVue,
    TextGorunumCellRenderer,
    DurumGorunumCellRenderer,
    MpStokListesiButton
  },
  methods: {
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return "";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return `${formatted}` + sign;
      }
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-1").then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    stokKaydet() {
      var vm = this;
      var vs = this.$vs;
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      if (vm.STOCKNO != "" && vm.STOCKNAME != "") {
        const args = {
          STOCKID: vm.STOCKID,
          STOCKNO: vm.STOCKNO,
          STOCKTYPE: vm.STOCKTYPE.val,
          STOCKNAME: vm.STOCKNAME,
          STOCKNAME2: vm.STOCKNAME2,
          STATUS: vm.STATUS.val,
          DEPOID: vm.DEPOTIDCODE,
          UNIT: vm.UNITCODE,
          VAT: vm.VATSALES,
          VATPURCHASE: vm.VATPURCHASE == "" ? vm.VATSALES : vm.VATPURCHASE,
          GROUPCODE: vm.GROUPCODECODE,
          SPECCODE1: vm.SPECCODE1CODE,
          SPECCODE2: vm.SPECCODE2CODE,
          SPECCODE3: vm.SPECCODE3CODE,
          SPECCODE4: vm.SPECCODE4CODE,
          SPECCODE5: vm.SPECCODE5CODE,
          SEASON: vm.SEASON,
          BRAND: vm.BRAND,
          MODEL: vm.MODEL,
          CATAGORY1: vm.CATAGORY1CODE,
          CATAGORY2: vm.CATAGORY2CODE,
          CATAGORY3: vm.CATAGORY3CODE,
          CATAGORY4: vm.CATAGORY4CODE,
          CATAGORY5: vm.CATAGORY5CODE,
          CURRCODE: vm.CURRCODE,
          PRICE1: vm.PRICE1,
          PRICE2: vm.PRICE2,
          PRICE3: vm.PRICE3,
          PRICE4: vm.PRICE4,
          PRICE5: vm.PRICE5,
          BARCODE: vm.BARCODE,
          BARCODE1: vm.BARCODE1,
          BARCODE2: vm.BARCODE2,
          BARCODE3: vm.BARCODE3,
          BARCODE4: vm.BARCODE4,
          CUSTOMERSTOCKNO: vm.CUSTOMERSTOCKNO,
          SUPPLIERSTOCKNO: vm.SUPPLIERSTOCKNO,
          WEBSTOCK: vm.WEBSTOCK == true || vm.WEBSTOCK == 1 ? 1 : 0,
          ORIGIN: vm.ORIGIN,
          BARKOD: vm.BARKOD,
          DESCRIPTION: vm.DESCRIPTION,
          NOTES: vm.NOTES,
          INSERTDATE: vm.INSERTDATE,
          INSERTUSER: state.UserId,
          EDITDATE: vm.EDITDATE,
          EDITUSER: vm.EDITUSER,
          ISLEM: "",
          ARANAN: "",
          COMPANYID: state.MusteriId,
          FOLLOWLOT: vm.LOTKAYIT == true || vm.LOTKAYIT == 1 ? 1 : 0,

          token: Store.state.tokenId
        };
        console.log(args);

        soap.createClient(url, function(err, client) {
          client.STOCK(args, function(err, result) {
            if (result.STOCKResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = JSON.parse(result.STOCKResult);
            try {
              if (vm.veriler.response == "Ok") {
                vs.notify({
                  title: "Stok Kayıt",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
                vm.$refs["modal-yeniStok"].hide();
                vm.getStokList();

                vm.STOCKID = "";
                vm.STOCKNO = "";
                vm.STOCKNAME = "";
                vm.STOCKNAME2 = "";
                vm.STATUS = "";
                vm.DEPOID = "";
                vm.UNIT = "";
                vm.VATSALES = "";
                vm.VATPURCHASE = "";
                vm.GROUPCODE = "";
                vm.SPECCODE1 = "";
                vm.SPECCODE2 = "";
                vm.SPECCODE3 = "";
                vm.SPECCODE4 = "";
                vm.SPECCODE5 = "";
                vm.SEASON = "";
                vm.BRAND = "";
                vm.MODEL = "";
                vm.CATAGORY1 = "";
                vm.CATAGORY2 = "";
                vm.CATAGORY3 = "";
                vm.CATAGORY4 = "";
                vm.CATAGORY5 = "";
                vm.CURRCODE = "";
                vm.PRICE1 = "";
                vm.PRICE2 = "";
                vm.PRICE3 = "";
                vm.PRICE4 = "";
                vm.PRICE5 = "";
                vm.BARCODE = "";
                vm.BARCODE1 = "";
                vm.BARCODE2 = "";
                vm.BARCODE3 = "";
                vm.BARCODE4 = "";
                vm.CUSTOMERSTOCKNO = "";
                vm.SUPPLIERSTOCKNO = "";
                vm.WEBSTOCK = "";
                vm.ORIGIN = "";
                vm.BARKOD = "";
                vm.DESCRIPTION = "";
                vm.NOTES = "";
                vm.LOTKAYIT = "";

                vm.UNITCODE = "";
                vm.DEPOTIDCODE = "";
                vm.GROUPCODECODE = "";
                vm.SPECCODE1CODE = "";
                vm.SPECCODE2CODE = "";
                vm.SPECCODE3CODE = "";
                vm.SPECCODE4CODE = "";
                vm.SPECCODE5CODE = "";
                vm.CURRCODECODE = "";
                vm.CATAGORY1CODE = "";
                vm.CATAGORY2CODE = "";
                vm.CATAGORY3CODE = "";
                vm.CATAGORY4CODE = "";
                vm.CATAGORY5CODE = "";
              } else {
                vs.notify({
                  title: "Stok Kayıt",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
              }
            } catch (error) {
              vs.notify({
                title: "Stok Kayıt",
                text: "Beklenmedik Hata",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    secTanim(index) {
      this[this.items[index].ROOTFIELD] =
        this.items[index].aciklama + "/" + this.items[index].kod;
      this[this.items[index].ROOTFIELD + "CODE"] = this.items[index].kod;
      this.$refs["modal-secimYap"].hide();
    },
    getTanimList() {
      var vm = this;
      vm.nextTodoId = 1;
      vm.items = [
        {
          id: 1,
          aciklama: "",
          kod: "",
          disabled: false,
          ROOT: "",
          ROOTFIELD: "",
          COMPANYID: ""
        }
      ];
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        COMPANYID: state.MusteriId,
        ROOT:
          vm.genelTanim == "UNIT" || vm.genelTanim == "DEPOTID"
            ? ""
            : "VE_STOCK",
        ROOTFIELD: vm.genelTanim
      };
      soap.createClient(url, function(err, client) {
        client.TANIMLIST(args, function(err, result) {
          if (result.TANIMLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.TANIMLISTResult);
          vm.veriler.forEach((val, index) => {
            vm.nextTodoId++;
            vm.items.push({
              kod: val.CODE,
              aciklama: val.DESCRIPTION,
              disabled: true,
              id: vm.nextTodoId,
              ROOT: val.ROOT,
              ROOTFIELD: val.ROOTFIELD,
              COMPANYID: val.COMPANYID
            });
          });
        });
      });
    },
    addTanim(index, islem) {
      var vm = this;
      var vs = this.$vs;
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      if (vm.items[index].kod == "") {
        vs.notify({
          title: "Tanım Ekleme",
          text: "Kod alanı zorunludur",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        const args = {
          token: Store.state.tokenId,
          COMPANYID: state.MusteriId,
          ROOT:
            vm.genelTanim == "UNIT" || vm.genelTanim == "DEPOTID"
              ? ""
              : "VE_STOCK",
          ROOTFIELD: vm.genelTanim,
          ISLEM: islem,
          CODE: vm.items[index].kod.replace("/", "-"),
          DESCRIPTION: vm.items[index].aciklama.replace("/", "-")
        };

        soap.createClient(url, function(err, client) {
          client.TANIMISLEM(args, function(err, result) {
            if (result.TANIMISLEMResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.TANIMISLEMResult);
              if (vm.veriler.response == "Ok") {
                vs.notify({
                  title: "Tanım Ekleme",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
                vm.items[index].kod = "";
                vm.items[index].aciklama = "";
                vm.getTanimList();
              } else
                vs.notify({
                  title: "Tanım Ekleme",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center"
                });
            } catch (error) {
              vs.notify({
                title: "Tanım Ekleme",
                text: "Tanım Kaydı sırasında hata oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      }
    },

    secimYap(tanim) {
      this.$refs["modal-secimYap"].show();
      this.genelTanim = tanim;
      this.getTanimList();
    },
    yeniKayit() {
      this.startIndexValue = 0;
      this.COMPANYID = "";
      this.STOCKID = "";
      this.STOCKNO = "";
      this.STOCKNAME = "";
      this.STOCKNAME2 = "";
      this.STATUS = {
        name: "Aktif",
        val: "2"
      };
      this.DEPOTID = "";
      this.UNIT = "";
      this.VATSALES = "";
      this.VATPURCHASE = "";
      this.GROUPCODE = "";
      this.SPECCODE1 = "";
      this.SPECCODE2 = "";
      this.SPECCODE3 = "";
      this.SPECCODE4 = "";
      this.SPECCODE5 = "";
      this.SEASON = "";
      this.BRAND = "";
      this.MODEL = "";
      this.CATAGORY1 = "";
      this.CATAGORY2 = "";
      this.CATAGORY3 = "";
      this.CATAGORY4 = "";
      this.CATAGORY5 = "";
      this.CURRCODE = "";
      this.PRICE1 = "";
      this.PRICE2 = "";
      this.PRICE3 = "";
      this.PRICE4 = "";
      this.PRICE5 = "";
      this.BARCODE = "";
      this.BARCODE1 = "";
      this.BARCODE2 = "";
      this.BARCODE3 = "";
      this.BARCODE4 = "";
      this.CUSTOMERSTOCKNO = "";
      this.SUPPLIERSTOCKNO = "";
      this.WEBSTOCK = "";
      this.LOTKAYIT = "";

      this.ORIGIN = "";
      this.DESCRIPTION = "";
      this.NOTES = "";
      this.INSERTDATE = "";
      this.INSERTUSER = "";
      this.EDITDATE = "";
      this.EDITUSER = "";
      this.STOCKTYPE = "";

      this.UNITCODE = "";
      this.DEPOTIDCODE = "";
      this.GROUPCODECODE = "";
      this.SPECCODE1CODE = "";
      this.SPECCODE2CODE = "";
      this.SPECCODE3CODE = "";
      this.SPECCODE4CODE = "";
      this.SPECCODE5CODE = "";
      this.CURRCODECODE = "";
      this.CATAGORY1CODE = "";
      this.CATAGORY2CODE = "";
      this.CATAGORY3CODE = "";
      this.CATAGORY4CODE = "";
      this.CATAGORY5CODE = "";
      this.$refs["modal-yeniStok"].show();
    },
    kayitGuncelle(stokDetayVal) {
      console.log(stokDetayVal);
      this.COMPANYID = stokDetayVal.COMPANYID;
      this.STOCKID = stokDetayVal.STOCKID;
      this.STOCKNO = stokDetayVal.STOCKNO;
      this.STOCKTYPE = {
        name:
          stokDetayVal.STOCKTYPE == 900
            ? "Mamül"
            : stokDetayVal.STOCKTYPE == 901
            ? "Yarı Mamül"
            : stokDetayVal.STOCKTYPE == 902
            ? "Ham Madde"
            : stokDetayVal.STOCKTYPE == 903
            ? "Diğer"
            : stokDetayVal.STOCKTYPE == 906
            ? "Yardımcı Malzeme"
            : "Sarf Malzeme",
        val: stokDetayVal.STOCKTYPE
      };
      this.STOCKNAME = stokDetayVal.STOCKNAME;
      this.STOCKNAME2 = stokDetayVal.STOCKNAME2;
      this.STATUS = {
        name: stokDetayVal.STATUS == "2" ? "Aktif" : "Pasif",
        val: stokDetayVal.STATUS
      };
      this.DEPOTID = stokDetayVal.DEPOTID;
      this.UNIT = stokDetayVal.UNIT;
      this.VATSALES = stokDetayVal.VATSALES;
      this.VATPURCHASE = stokDetayVal.VATPURCHASE;
      this.GROUPCODE = stokDetayVal.GROUPCODE;
      this.SPECCODE1 = stokDetayVal.SPECCODE1;
      this.SPECCODE2 = stokDetayVal.SPECCODE2;
      this.SPECCODE3 = stokDetayVal.SPECCODE3;
      this.SPECCODE4 = stokDetayVal.SPECCODE4;
      this.SPECCODE5 = stokDetayVal.SPECCODE5;
      this.SEASON = stokDetayVal.SEASON;
      this.BRAND = stokDetayVal.BRAND;
      this.MODEL = stokDetayVal.MODEL;
      this.CATAGORY1 = stokDetayVal.CATAGORY1;
      this.CATAGORY2 = stokDetayVal.CATAGORY2;
      this.CATAGORY3 = stokDetayVal.CATAGORY3;
      this.CATAGORY4 = stokDetayVal.CATAGORY4;
      this.CATAGORY5 = stokDetayVal.CATAGORY5;
      this.CURRCODE = stokDetayVal.CURRCODE;
      this.PRICE1 = stokDetayVal.PRICE1;
      this.PRICE2 = stokDetayVal.PRICE2;
      this.PRICE3 = stokDetayVal.PRICE3;
      this.PRICE4 = stokDetayVal.PRICE4;
      this.PRICE5 = stokDetayVal.PRICE5;
      this.BARCODE = stokDetayVal.BARCODE;
      this.BARCODE1 = stokDetayVal.BARCODE1;
      this.BARCODE2 = stokDetayVal.BARCODE2;
      this.BARCODE3 = stokDetayVal.BARCODE3;
      this.BARCODE4 = stokDetayVal.BARCODE4;
      this.CUSTOMERSTOCKNO = stokDetayVal.CUSTOMERSTOCKNO;
      this.SUPPLIERSTOCKNO = stokDetayVal.SUPPLIERSTOCKNO;
      this.WEBSTOCK = stokDetayVal.WEBSTOCK;
      this.LOTKAYIT = stokDetayVal.LOTKAYIT;

      this.ORIGIN = stokDetayVal.ORIGIN;
      this.DESCRIPTION = stokDetayVal.DESCRIPTION;
      this.NOTES = stokDetayVal.NOTES;
      this.INSERTDATE = stokDetayVal.INSERTDATE;
      this.INSERTUSER = stokDetayVal.INSERTUSER;
      this.EDITDATE = stokDetayVal.EDITDATE;
      this.EDITUSER = stokDetayVal.EDITUSER;

      this.UNITCODE = stokDetayVal.UNITCODE;
      this.DEPOTIDCODE = stokDetayVal.DEPOTIDCODE;
      this.GROUPCODECODE = stokDetayVal.GROUPCODECODE;
      this.SPECCODE1CODE = stokDetayVal.SPECCODE1CODE;
      this.SPECCODE2CODE = stokDetayVal.SPECCODE2CODE;
      this.SPECCODE3CODE = stokDetayVal.SPECCODE3CODE;
      this.SPECCODE4CODE = stokDetayVal.SPECCODE4CODE;
      this.SPECCODE5CODE = stokDetayVal.SPECCODE5CODE;
      this.CURRCODECODE = stokDetayVal.CURRCODECODE;
      this.CATAGORY1CODE = stokDetayVal.CATAGORY1CODE;
      this.CATAGORY2CODE = stokDetayVal.CATAGORY2CODE;
      this.CATAGORY3CODE = stokDetayVal.CATAGORY3CODE;
      this.CATAGORY4CODE = stokDetayVal.CATAGORY4CODE;
      this.CATAGORY5CODE = stokDetayVal.CATAGORY5CODE;
      this.$refs["modal-yeniStok"].show();
    },
    handscroll(el) {},

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    getStokList() {
      var vm = this;
      var vs = this.$vs;
      if (vm.arananDeger != "")
        vs.loading({
          background: "#0064fa",
          color: "danger",
          container: "#button-with-loading-yeni",
          scale: 0.45
        });
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        COMPANYID: state.MusteriId,
        ARANAN: vm.arananDeger,
        ISLEM: "LIST",
        token: Store.state.tokenId
      };
      soap.createClient(url, function(err, client) {
        client.STOCK(args, function(err, result) {
          if (result.STOCKResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          setTimeout(() => {
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          }, 1000);

          vm.veriler = JSON.parse(result.STOCKResult);
          vm.rowdata = JSON.parse(vm.veriler.jsonData);
          console.log(vm.rowdata)
        });
      });
    }
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("stokKayitGuncelle", stokDetayVal => {
      this.kayitGuncelle(stokDetayVal);
    });
  },
  beforeDestroy() {
    this.$root.$off("stokKayitGuncelle");
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 200,
        field: "",
        cellRendererFramework: "MpStokListesiButton"
      },
      {
        headerName: "Stok Tipi",
        field: "STOCKTYPE",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "STOCKTYPEGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Kod",
        children: [
          {
            width: 150,
            headerName: "Stok Kodu",
            field: "STOCKNO",
            sortable: true,
            filter: "agSetColumnFilter",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true
          },
          {
            width: 100,
            headerName: "Müşteri Stok Kodu",
            field: "CUSTOMERSTOCKNO",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            columnGroupShow: "open",
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Tedarikçi Stok Kodu",
            field: "SUPPLIERSTOCKNO",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          }
        ]
      },

      {
        headerName: "Detay",
        children: [
          
          {
            width: 250,
            headerName: "Stok Adı",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            field: "STOCKNAME",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          {
            headerName: "Depo",
            width: 100,
            columnGroupShow: "open",
            field: "DEPOTID",
            sortable: true,
            filter: "agSetColumnFilter",
          },
          {
            headerName: "Adet",
            width: 100,
            columnGroupShow: "open",
            field: "QREM",
            sortable: true,
            filter: "agSetColumnFilter",
          },
          {
            width: 100,
            columnGroupShow: "open",
            headerName: "Stok Adı 2",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            field: "STOCKNAME2",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            headerName: "Sezon",
            field: "SEASON",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            headerName: "Marka",
            field: "BRAND",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            headerName: "Model",
            field: "MODEL",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          
          {
            width: 100,
            columnGroupShow: "open",
            headerName: "Birim",
            field: "UNIT",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Kdv",
            columnGroupShow: "open",
            field: "VATSALES",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Orijin",
            columnGroupShow: "open",
            field: "ORIGIN",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            sortable: true,
            filter: "agTextColumnFilter"
          }
        ]
      },
      {
        headerName: "Grup",
        children: [
          {
            width: 150,
            headerName: "Grup Kodu",
            field: "GROUPCODE",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            sortable: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            columnGroupShow: "open",
            headerName: "Özel Kod 1",
            field: "SPECCODE1",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            headerName: "Özel Kod 2",
            width: 100,
            columnGroupShow: "open",
            field: "SPECCODE2",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            columnGroupShow: "open",
            headerName: "Özel Kod 3",
            field: "SPECCODE3",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Özel Kod 4",
            columnGroupShow: "open",
            field: "SPECCODE4",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Özel Kod 5",
            columnGroupShow: "open",
            field: "SPECCODE5",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          }
        ]
      },
      {
        headerName: "Kategori",
        children: [
          {
            width: 120,
            headerName: "Kategori 1",
            field: "CATAGORY1",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Kategori 2",
            field: "CATAGORY2",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Kategori 3",
            field: "CATAGORY3",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Kategori 4",
            field: "CATAGORY4",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Kategori 5",
            field: "CATAGORY5",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            columnGroupShow: "open",
            filter: "agSetColumnFilter"
          }
        ]
      },
      {
        headerName: "Fiyat",
        children: [
          {
            width: 120,
            headerName: "Fiyat 1",
            field: "PRICE1",
            sortable: true,
            wrapText: true,
            autoHeight: true,
            type: "rightAligned",
            cellRenderer: "ReceteStokPriceCellRenderer",
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Fiyat 2",
            field: "PRICE2",
            sortable: true,
            columnGroupShow: "open",
            wrapText: true,
            autoHeight: true,
            type: "rightAligned",
            cellRenderer: "ReceteStokPriceCellRenderer",
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Fiyat 3",
            field: "PRICE3",
            sortable: true,
            columnGroupShow: "open",
            type: "rightAligned",
            cellRenderer: "ReceteStokPriceCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Fiyat 4",
            field: "PRICE4",
            sortable: true,
            type: "rightAligned",
            columnGroupShow: "open",
            wrapText: true,
            autoHeight: true,
            cellRenderer: "ReceteStokPriceCellRenderer",
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Döviz",
            field: "CURRCODE",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            sortable: true,
            filter: "agSetColumnFilter",
          }
        ]
      },
      {
        headerName: "Barkod",
        children: [
          {
            width: 100,
            headerName: "Barkod",
            field: "BARCODE",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Barkod 1",
            field: "BARCODE1",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Barkod 2",
            field: "BARCODE2",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Barkod 3",
            field: "BARCODE3",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Barkod 4",
            field: "BARCODE4",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agTextColumnFilter"
          }
        ]
      },
      {
        headerName: "Açıklama",
        field: "DESCRIPTION",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        filterParams: { caseSensitive: true, defaultOption: "startsWith" }
      },
      {
        headerName: "Notlar",
        field: "NOTES",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        filterParams: { caseSensitive: true, defaultOption: "startsWith" }
      },
      {
        headerName: "Durum",
        field: "STATUS",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "DurumGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        filterParams: { caseSensitive: true, defaultOption: "startsWith" }
      }
    ];
  }
};
</script>
<style lang="scss">
[dir] .vx-card .vx-card__collapsible-content .vx-card__body {
  padding: 0px !important;
}
.scroll-hand {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.vs-card--content {
  margin-bottom: 5px !important;
}
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir] .modal-title {
  margin-bottom: 0;
  color: #7367f0 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.my-fancy-class {
  background-color: #7367f0;
}
#main {
  width: 200px;
  height: 200px;
  border: 1px solid #c3c3c3;
  display: flex;
  flex-wrap: wrap;
}

#main div {
  width: 50px;
  height: 50px;
}

[dir] .vue-form-wizard .wizard-tab-content {
  padding: 0px !important;
}
[dir] .vue-form-wizard .wizard-header {
  padding: 0px !important;
}
</style>
